export const toLen = (str: string, len: number, symbol = ' ') => {
    for (let i = 0; i < len - str.length; i++) {
        str = symbol + str
    }
    console.log(str)
    return str
}
export const toHHMMString = (totalMinutes: number) => {
    const hours = Math.floor(totalMinutes / 60).toString().padStart(2, '0')
    const minutes = (totalMinutes % 60).toString().padStart(2, '0')
    return `${hours}:${minutes}`
}